// extracted by mini-css-extract-plugin
export default {"title":"Certification_title__pUGIn","description":"Certification_description__MF4Z8"};